export const Card = ({ children, className = "", testid, ...rest }) => (
  <div data-testid={testid} className={`rounded-2xl border border-slate-200/70 bg-white shadow-[0_1px_2px_rgba(10,35,74,0.04),0_14px_34px_-20px_rgba(10,35,74,0.22)] ${className}`} {...rest}>{children}</div>
);

export const Label = ({ children }) => <span className="mb-1 block text-[11px] font-bold uppercase tracking-[0.14em] text-slate-400">{children}</span>;

const inputCls = "h-10 w-full rounded-lg border border-slate-200 bg-[#F7F8FA] px-3 text-sm text-[#0A234A] outline-none transition-[border-color,background-color,box-shadow] duration-200 focus:border-[#FF5722]/60 focus:bg-white focus:ring-4 focus:ring-[#FF5722]/10";
export const Field = (p) => <input {...p} className={`${inputCls} ${p.className || ""}`} />;
export const Select = (p) => <select {...p} className={inputCls} />;

export const Btn = ({ children, primary, danger, ghost, testid, className = "", ...p }) => {
  const tone = primary
    ? "bg-[#FF5722] text-white shadow-[0_6px_16px_-6px_rgba(255,87,34,0.65)] hover:bg-[#e64a16]"
    : danger
      ? "border border-red-200 bg-white text-red-600 hover:bg-red-50"
      : ghost
        ? "text-[#0A234A] hover:bg-slate-100"
        : "border border-slate-300 bg-white text-[#0A234A] hover:border-slate-400 hover:bg-slate-50";
  return (
    <button data-testid={testid} {...p} className={`rounded-lg px-4 py-2 text-sm font-bold transition-[background-color,box-shadow,transform] duration-200 active:scale-[0.97] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#FF5722]/40 disabled:opacity-40 ${tone} ${className}`}>{children}</button>
  );
};

export const Head = ({ title, sub, children }) => (
  <div className="mb-7 flex flex-wrap items-end justify-between gap-3 border-b border-slate-200/80 pb-5">
    <div>
      <span className="mb-2 block h-1 w-9 rounded-full bg-[#FF5722]" />
      <h1 className="font-display text-3xl font-bold leading-[1.05] tracking-tight text-[#0A234A]">{title}</h1>
      {sub && <p className="mt-2 max-w-2xl text-[15px] leading-relaxed text-slate-500">{sub}</p>}
    </div>
    {children && <div className="flex flex-wrap items-center gap-2">{children}</div>}
  </div>
);

export const Pill = ({ children, tone = "bg-slate-100 text-slate-600", testid }) => <span data-testid={testid} className={`inline-block rounded-full px-2.5 py-0.5 text-xs font-bold ${tone}`}>{children}</span>;

export const Stat = ({ label, value, hint, testid, accent }) => (
  <Card className="p-5" testid={testid}>
    <Label>{label}</Label>
    <p className={`font-display text-3xl font-bold tracking-tight ${accent ? "text-[#FF5722]" : "text-[#0A234A]"}`}>{value}</p>
    {hint && <p className="mt-1 text-xs font-medium text-slate-400">{hint}</p>}
  </Card>
);

export const Empty = ({ title, body, children, testid }) => (
  <div data-testid={testid} className="rounded-2xl border border-dashed border-slate-300 bg-white/60 px-6 py-12 text-center">
    <p className="font-display text-lg font-bold text-[#0A234A]">{title}</p>
    {body && <p className="mx-auto mt-1 max-w-md text-sm text-slate-500">{body}</p>}
    {children && <div className="mt-5 flex justify-center gap-2">{children}</div>}
  </div>
);

export const Notice = ({ tone = "error", children, testid }) => (
  <div data-testid={testid} className={`rounded-lg border p-3 text-sm font-semibold ${tone === "error" ? "border-red-200 bg-red-50 text-red-600" : "border-emerald-200 bg-emerald-50 text-emerald-700"}`}>{children}</div>
);

export const Table = ({ head, children, testid }) => (
  <div className="overflow-x-auto" data-testid={testid}>
    <table className="w-full text-left text-sm">
      <thead><tr className="border-b border-slate-200 text-[11px] font-bold uppercase tracking-[0.12em] text-slate-400">{head.map((h) => <th key={h} className="px-4 py-3 font-bold">{h}</th>)}</tr></thead>
      <tbody className="divide-y divide-slate-100">{children}</tbody>
    </table>
  </div>
);

export const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
export const when = (s) => (s ? new Date(s).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
